module.exports = __webpack_public_path__ + "media/Audio18_j.c4393418.wav";